import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

import Close from '@mui/icons-material/Close';
import {
  InputAdornment,
  InputLabel,
  FormControl,
  OutlinedInput
} from '@mui/material';
const PREFIX = 'SearchBox';

const classes = {
  root: `${PREFIX}-root`
};

const Root = styled('div')({
  [`& .${classes.root}`]: {
    '& .MuiInput-underline:after': {
      borderBottomColor: '#fbb040'
    },
    '& .MuiInputBase-input': {
      fontSize: '18px'
    }
  }
});

const SearchBox = (props: {
  open: boolean;
  toggleSearchBoxOpen: () => void;
}) => {
  const [searchText, setSearchText] = useState('');

  const search = (
    keyUpEvent: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (keyUpEvent.key === 'Enter') {
      props.toggleSearchBoxOpen();
      window.location.assign(`/search?text=${searchText}`);
    }
  };

  if (!props.open) {
    return null;
  }

  return (
    <Root
      className='search-box'
      style={{
        height: props.open ? 'auto' : 0
      }}
    >
      <div className='search-box__inner'>
        <div className='search-box__main'>
          <FormControl variant='outlined' fullWidth>
            <InputLabel htmlFor='search'>Search</InputLabel>
            <OutlinedInput
              fullWidth
              autoFocus
              type='search'
              placeholder='Press Enter to Search'
              value={searchText}
              // onKeyPress={(event) => search(event)}
              onKeyUp={(event) => search(event)}
              onChange={(event) => setSearchText(event.target.value)}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='Close'
                    edge='end'
                    onClick={() => {
                      setSearchText('');
                      props.toggleSearchBoxOpen();
                    }}
                  >
                    <Close />
                  </IconButton>
                </InputAdornment>
              }
              label='Password'
            />
          </FormControl>
        </div>
      </div>
    </Root>
  );
};

export default SearchBox;
